












































































import { Component, Vue } from "vue-property-decorator";
import { ReportHistory } from "@/typescript/models/reports/types";
import { Moment } from "@/typescript/lib/common/moment";
import TItemComponent from "@/components/common/table/TItemComponent.vue";
import TableComponent from "@/components/common/table/TableComponent.vue";
import TbodyComponent from "@/components/common/table/TbodyComponent.vue";
import TheadComponent from "@/components/common/table/TheadComponent.vue";
import EllipsisComponent from "@/components/common/parts/EllipsisComponent.vue";
import ReportHistoriesMenubarComponent from "@/components/pages/reports/ReportHistoriesMenubarComponent.vue";
import PagenationComponent from "@/components/common/parts/PagenationComponent.vue";
import { getStoreReportHistoryApi } from "@/typescript/api_client/emesh_api/reports/store_report_history_api";
import { getStoreReportHistoryDownloadApi } from "@/typescript/api_client/emesh_api/reports/store_report_history_download_api";
export { ReportHistory };

@Component({
  components: {
    TItemComponent,
    TableComponent,
    TbodyComponent,
    TheadComponent,
    ReportHistoriesMenubarComponent,
    PagenationComponent,
    EllipsisComponent
  }
})
export default class ReportHistoriesComponent extends Vue {
  $refs!: {
    report_histories_menubar_component: ReportHistoriesMenubarComponent;
  };

  API_DATETIME = "YYYYMMDDHHmmss";
  reports: ReportHistory[] = [];
  currentPageNo: number = 1;

  showTargetDate: string = new Moment("YYYY/MM").getFormatDate();

  async setReportHistory(since: string) {
    const reports = await getStoreReportHistoryApi({
      store_id: this.$route.params.store_id,
      since: since,
      until: new Moment(this.API_DATETIME, since, this.API_DATETIME).getEndOf(
        "month"
      )
    });
    this.reports = reports;
  }

  getPagenationReports() {
    if (!this.$refs["report_histories_menubar_component"]) return [];
    const startNum = this.$refs.report_histories_menubar_component.getItemStartNum();
    const endNum = this.$refs.report_histories_menubar_component.getItemEndNum();
    return this.reports.slice(startNum - 1, endNum);
  }

  changePage(num: number) {
    this.currentPageNo = num;
  }

  moveNextPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo += 1;
  }

  movePrevPage(isMove: boolean) {
    if (!isMove) return;
    this.currentPageNo -= 1;
  }

  changeCalendar(value: string) {
    this.showTargetDate = value;
    const since = new Moment(
      this.API_DATETIME,
      this.showTargetDate
    ).getFormatDate();
    this.setReportHistory(since);
    this.currentPageNo = 1;
  }

  convertDate(date: string, showSeconds: boolean = false): string {
    const format = showSeconds ? "YYYY/MM/DD HH:mm:ss" : "YYYY/MM/DD HH:mm";
    const moment = new Moment(format, date, this.API_DATETIME);
    return moment.getFormatDate();
  }

  convertReportType(type: number): string {
    switch (type) {
      case 1:
        return "月次";
      case 2:
        return "週次";
      case 3:
        return "日次";
    }

    return "期間選択";
  }

  convertOutputFormat(outputFormat: number): string {
    return outputFormat == 1 ? "PDF" : "CSV";
  }

  // 2023.05.31 レポートファイル直リンクからAPIを介す処理に変更
  getReportFile(report) {
    let fileName = "";
    if (report.url) {
      fileName = report.url.split("/").pop();
    }
    getStoreReportHistoryDownloadApi(report.history_no, fileName);
  }
}
